import { type PropsWithChildren, createContext, useContext } from 'react';

import { useAccountQuery } from 'reservations/account/queries/useAccountQuery';
import type { SelectAccountResponse } from 'reservations/account/queries/useAccountQuery';
import { ErrorScreen } from 'reservations/base/components/ErrorScreen';

const AccountContext = createContext<SelectAccountResponse | null>(null);

const AccountProvider = ({ children }: PropsWithChildren) => {
  const { data, isPending, isError } = useAccountQuery();

  if (isPending) {
    return <></>;
  }

  // istanbul ignore next
  if (isError) {
    return <ErrorScreen />;
  }

  return (
    <AccountContext.Provider value={data}>{children}</AccountContext.Provider>
  );
};

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (context == null) {
    throw new Error('useAccount must be used within AccountProvider');
  }

  return context;
};

export default AccountProvider;
